import axios from "axios";
import Vue from "vue";
import router from "@/router";
import { clearAuthState, getToken } from "@/utils/auth";

// 使用 Vue.prototype.$message 而非直接导入 element-ui Message，
// 确保经过 globalMessageClose 插件代理，支持"一键关闭"功能。
// 用函数延迟取值，保证插件在 main.js 中完成注册后再使用。
const Message = (options) => Vue.prototype.$message(options);

const responseError = (message, response) => {
  const error = new Error(message);
  if (response) error.response = { status: response.status, data: response.data };
  return error;
};

let baseURL =
  process.env.VUE_APP_API_BASE_URL || 'https://mj.api.meidawenhua.com/'

const service = axios.create({
  baseURL,
  timeout: 60 * 1000,
  headers: {
    "Content-Type": "application/json",
  },
});


service.getBaseURL = () => baseURL;

service.interceptors.request.use(
  (config) => {
    const token = getToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

service.interceptors.response.use(
  (response) => {
    const res = response.data || {};

    if (res.code !== 0) {
      const errorMessage = res.message || "请求失败";

      if (res.code === 401) {
        clearAuthState();

        const currentRoute = router.currentRoute.fullPath || "/";
        if (router.currentRoute.path !== "/login") {
          router.replace({
            path: "/login",
            query: { redirect: currentRoute },
          });
        }
      }

      if (!response.config?.silentError) {
        Message({ type: 'error', message: errorMessage, showClose: true, duration: 0 });
      }
      return Promise.reject(responseError(errorMessage, response));
    }

    return res;
  },
  (error) => {
    // 主动取消请求（例如页面离开时 cancelToken.cancel）不提示全局错误
    if (axios.isCancel(error) || error?.code === 'ERR_CANCELED' || error?.__CANCEL__) {
      return Promise.reject(error);
    }

    const status = error.response?.status;
    const resData = error.response?.data;

    if (status === 401) {
      clearAuthState();
      const currentRoute = router.currentRoute.fullPath || "/";
      if (router.currentRoute.path !== "/login") {
        router.replace({
          path: "/login",
          query: { redirect: currentRoute },
        });
      }
    }

    // 优先使用接口返回的业务错误信息
    const errorMessage = resData?.message || error.message || "网络异常，请稍后重试";
    if (!error.config?.silentError) {
      Message({ type: 'error', message: errorMessage, showClose: true, duration: 0 });
    }
    return Promise.reject(responseError(errorMessage, error.response));
  }
);

export default service;
